const getDefaultState = () => ({
  rentals: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveError: undefined,
    saveLoading: false,
    newRentalItem: {
      id: undefined,
      bookingId: undefined,
      bookingParticipantId: undefined,
      height: undefined,
      weight: undefined,
      shoeSize: undefined,
    },
    newRentalProductItem: {
      productsSkiRentalSeasonId: undefined,
      productsSkiRentalSkiTypeId: undefined,
      productsSkiRentalPackageId: undefined,
      productsSkiRentalPersonCategoryId: undefined,
      productsSkiRentalLevelId: undefined,
      status: 'initiated',
      salesType: 'booking',
      supplierRef: undefined,
      firstSkiDay: undefined,
      numberOfDays: undefined,
      price: undefined,
      priceNet: undefined,
      currencyNet: undefined,
      supplierName: undefined,
      name: undefined,
      seasonName: undefined,
      skiTypeName: undefined,
      packageName: undefined,
      personCategoryName: undefined,
      levelName: undefined,
      nameSupplier: undefined,
      seasonNameSupplier: undefined,
      skiTypeNameSupplier: undefined,
      packageNameSupplier: undefined,
      personCategoryNameSupplier: undefined,
      levelNameSupplier: undefined,
      discount: undefined,
      discountNet: undefined,
      discountBookFrom: undefined,
      discountBookTo: undefined,
    },
  },
  bookingParticipants: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  levelTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  skiTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  packageTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  availableRentalProducts: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveError: undefined,
    saveLoading: false,
  },
  search: {
    selectedBookingParticipant: null,
    selectedStartDate: undefined,
    selectedNumberOfDays: 2,
    availableNumberOfDays: [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14],
    selectedMultipleLevelTypes: [],
    selectedMultipleSkiTypes: [],
    selectedAreaId: null,
  },
  changeProduct: {
    selectedBookingParticipantId: undefined,
    selectedPersonCategoryId: undefined,
    selectedStartDate: undefined,
    selectedNumberOfDays: undefined,
    selectedLevelTypeId: undefined,
    selectedSkiTypeId: undefined,
    selectedPackageTypeId: undefined,
  },
  pickupPlaces: {
    loading: false,
    error: false,
    items: [],
  },
  savePickupPlace: {
    loading: false,
    error: false,
    success: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/defaultState.js